// extracted by mini-css-extract-plugin
export default {"IconPlay":"IconPlay__IconPlay___yTADD"};